import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const Title = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).lobby;

  return (
    <Stack
      gap='16px'
      sx={{
        textAlign: 'center',
        mb: isDesktop ? '48px' : '32px',
      }}
    >
      <Typography variant={isDesktop ? 'h3' : 'h2'}>
        {dictionary.title}
      </Typography>
      <Typography
        variant={isDesktop ? 'h4' : 'h3'}
        sx={{ fontWeight: isDesktop ? 'bold !important' : 400 }}
      >
        {dictionary.subTitle}
      </Typography>
    </Stack>
  );
};
